export enum FormType {
    Color = 'color',
    Date = 'date',
    DateTimeLocal = 'datetime-local',
    Email = 'email',
    Month = 'month',
    Number = 'number',
    Password = 'password',
    Search = 'search',
    Tel = 'tel',
    Text = 'text',
    Time = 'time',
    Url = 'url',
    Week = 'week',
    Selector = 'select'
}
